import React, { useState } from "react";
import "./TopSearch.css";

const TopSearch = (props) => {
  const [userInput, setUserInput] = useState("");
  const onChangeHandler = (value) => {
    setUserInput(value);
    props.updateUserSearch(userInput);
  };

  return (
    <div className="image-container">
      <div className="heading-search">
        <h1 className="heading">Taste the World from Your Hub</h1>
        <div className="search-container">
          <input
            type="search"
            className="search-input"
            placeholder="Search..."
            onChange={(e) => onChangeHandler(e.target.value)}
          />
          <button className="search-button">Search</button>
        </div>
      </div>
    </div>
  );
};

export default TopSearch;
